import React, { FC } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import NotAuthorized from '../pages/NotAuthorized'
import Layout from '../components/layout/Layout'
import TopNav from '../components/layout/TopNav'
import PrivateRoute from './PrivateRoute'
import Home from '../pages/HomePage'
import SideMenu from '../components/layout/SideMenu'
import ProjectPage from '../pages/ProjectPage'
import SearchResultsPage from '../pages/SearchResultsPage'
import ProjectContentRouter from './ProjectContentRouter'

const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={
            <PrivateRoute>
              <Layout topNavComponent={<TopNav />}>
                <Home />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path='/:org'
          element={
            <PrivateRoute>
              <Layout topNavComponent={<TopNav />} sideMenuComponent={<SideMenu />}>
                <Home />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path='/:org/:project'
          element={
            <PrivateRoute>
              <Layout topNavComponent={<TopNav />} sideMenuComponent={<SideMenu />}>
                <ProjectPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path='/:org/search'
          element={
            <PrivateRoute>
              <Layout topNavComponent={<TopNav />} sideMenuComponent={<SideMenu />}>
                <SearchResultsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path='/:org/:project/*'
          element={
            <PrivateRoute>
              <ProjectContentRouter />
            </PrivateRoute>
          }
        />
        <Route path='/not-authorized' element={<NotAuthorized />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
